import { BaseTable, ColumnProp } from 'common/components/table/base';
import { useProducerWithThunks } from 'common/hooks/useProducer';
import {
  AccountOperating,
  AccountOperatingsActions,
} from 'common/state/accounts/actions';
import {
  AccountOperatingsState,
  defaultAccountOperatingsState,
} from 'common/state/accounts/states';
import { doGetAccountOperatings } from 'common/state/accounts/thunkActions';
import { accountOperatingsRecipe } from 'common/state/accounts/recipes';
import React, { useEffect, useMemo } from 'react';
import { Currency } from 'common/classes/currency';
import { mdiChessQueen } from '@mdi/js';
import { TableTitle } from 'common/components/tables';

export const AccountOperatingTable = () => {
  const [state, dispatch] = useProducerWithThunks<
    AccountOperatingsState,
    AccountOperatingsActions
  >(accountOperatingsRecipe, defaultAccountOperatingsState);

  const { operatings } = state;

  useEffect(() => {
    dispatch(doGetAccountOperatings());
  }, [dispatch]);

  const columns = useMemo(
    (): ColumnProp<AccountOperating>[] => [
      { key: 'name', title: 'Name' },
      {
        key: 'balance',
        title: 'Balance',
        valueFormatter: (row: AccountOperating) =>
          new Currency(row.balance, row.currency).toElement(),
        csvFormatter: (row) =>
          new Currency(row.balance, row.currency).toString({
            symbol: false,
          }),
        sortValueGenerator: (row: AccountOperating) => parseFloat(row.balance),
      },
    ],
    []
  );

  return (
    <>
      <TableTitle icon={mdiChessQueen} title="Operating Accounts" />
      <br />
      <BaseTable
        columns={columns}
        rows={operatings || []}
        csvName="Operating"
        isLoading={state.pending}
        error={state.error}
      />
    </>
  );
};
